<div class="related-topic-preview">
  <vnc-smart-link-preview [previewType]="'TOPIC'"
                          [previewData]="data?.previewData"
                          (click)="openSmartLinkEntity()"></vnc-smart-link-preview>
</div>
